import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Unidade } from '../../../models/unidade';
import { Uf } from '../../../models/uf';
import { DataService } from './data.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UnidadeService extends DataService {

  private url = this.urlApi + 'v1/unidade/';

  constructor(private http: HttpClient) {
    super();
  }

  getUnidades() {
    return this.http.get<Unidade[]>(this.url + 'getUnidades/')
      .catch(this.handleError);
  }

  getUnidadesCfc() {
    return this.http.get<Unidade[]>(this.url + 'getUnidadesCfc')
      .catch(this.handleError);
  }

  getUnidadesComGestor() {
    return this.http.get(this.url + 'getUnidadesComGestor')
      .catch(this.handleError);
  }

  getUnidadesParticipantes() {
    return this.http.get<Unidade[]>(this.url + 'getUnidadesParticipantes/')
      .catch(this.handleError);
  }

  getUnidade(id: string) {
    return this.http.get(this.url + 'getUnidade/' + id)
      .catch(this.handleError);
  }

  getUnidadeFull(id: string) {
    return this.http.get(this.url + 'getUnidadeFull/' + id)
      .catch(this.handleError);
  }

  getUnidadesByIdUf(idUf: string) {
    return this.http.get<Unidade[]>(this.url + 'getUnidadesByUf/' + idUf)
      .catch(this.handleError);
  }
  getUnidadesByIdUfSigla(siglaUf: string) {
    return this.http.get<Unidade[]>(this.url + 'getUnidadesByUf/' + siglaUf + '/sigla')
      .catch(this.handleError);
  }

  getUnidadesComEditalCfcByIdUf(idUf: string): Observable<Unidade[]> {
    return this.http.get(this.url + 'getUnidadesComEditalCfcByIdUf/' + idUf)
      .catch(this.handleError);
  }

  getUnidadesComEditalClinicaByIdUf(idUf: string) {
    return this.http.get<Unidade[]>(this.url + 'getUnidadesComEditalClinicaByIdUf/' + idUf)
      .catch(this.handleError);
  }

  getUnidadesParticipantesByFase(idFase) {
    return this.http.get(this.url + 'getUnidadesParticipantesByFase/' + idFase)
      .catch(this.handleError);
  }

  getUnidadesParticipantesByidUf(idUf) {
    return this.http.get(this.url + 'getUnidadesParticipantesByidUf/' + idUf)
      .catch(this.handleError);
  }

  getUnidadesParticipantesInscricoesAbertasByFase(idFase): any {
    return this.http.get(this.url + 'getUnidadesParticipantesInscricoesAbertasByFase/' + idFase)
      .catch(this.handleError);
  }

  getUnidadebyPage(take: string, skip: string) {
    return this.http.get<Unidade[]>(this.url + 'getUnidadebyPage/' + take + '/' + skip)
      .catch(this.handleError);
  }

  getListaUf() {
    return this.http.get<Uf[]>(this.url + 'getUf')
      .catch(this.handleError);
  }

  getUfsComEditalCfc(): any {
    return this.http.get<Uf[]>(this.url + 'getUfsComEditalCfc')
      .catch(this.handleError);
  }

  getUfsComEditalClinica(): any {
    return this.http.get<Uf[]>(this.url + 'getUfsComEditalClinica')
      .catch(this.handleError);
  }

  cadastrarInformacoesComplemetares(data: any) {
    console.log('aqui de novo');
    console.log(this.url + 'informacoesAdicionais');
    return this.http.post(this.url + 'informacoesAdicionais', data)
    .catch(this.handleError);
  }

  carregarInformacoesUnidade(idUnidade) {
    return this.http.get<Uf[]>(this.url + 'getInformacoesAdicionaisByIdUnidade/' + idUnidade)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/services/unidade.service.ts